// W4 — Role label personalisation utility.
// Reads the user's chosen role label (Founder / Owner / MD / CEO / Director /
// custom) from the user object passed in, with a sensible default when not set.
//
// Used wherever the platform addresses the user directly. Pass the current
// user from localStorage:
//   import { getRoleLabel, getCurrentUser } from '../utils/roleLabel';
//   const label = getRoleLabel(getCurrentUser());

export const DEFAULT_ROLE_LABEL = 'business leader';

export const ROLE_OPTIONS = [
  'Founder',
  'Owner',
  'Managing Director',
  'CEO',
  'Director',
];

export function getRoleLabel(user) {
  if (!user || typeof user !== 'object') return DEFAULT_ROLE_LABEL;
  const raw = user.roleLabel;
  if (typeof raw === 'string' && raw.trim()) return raw.trim();
  return DEFAULT_ROLE_LABEL;
}

// Convenience reader so consumers don't all duplicate the localStorage parse.
export function getCurrentUser() {
  try {
    const raw = localStorage.getItem('guruone_user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
